export function initSelectFields() {
    const selectFields = document.querySelectorAll('.form-select-field');

    selectFields.forEach(field => {
        const toggleBtn = field.querySelector('.form-select-toggle-btn');
        if (toggleBtn) {
            toggleBtn.addEventListener('click', () => {
                field.classList.toggle('field--toggled');
            });

            document.addEventListener('click', documentClicked.bind(null, field))

            const selectInput = field.querySelector('.form-select-input');
            const optionBtns = field.querySelectorAll('.form-select-opt-btn');
            optionBtns.forEach(optBtn => {
                optBtn.addEventListener('click', optBtnClicked.bind(null, field, selectInput));
            });
        }
    });

    function optBtnClicked(field, input, event) {
        if (field instanceof Element && input instanceof HTMLInputElement) {
            input.value = event.currentTarget.textContent.trim();
            input.dispatchEvent(new Event('change', { bubbles: true }));
            input.dispatchEvent(new Event('input', { bubbles: true }));
            field.classList.remove('field--toggled');
        }
    }

    function documentClicked(field, event) {
        if (field instanceof Element) {
            if (!field.contains(event.target)) {
                field.classList.remove('field--toggled');
            }
        }
    }
}